import React, {Component} from 'react';
import { connect } from 'react-redux';
import {NavLink, withRouter} from 'react-router-dom';
import Slider from 'react-slick';
import Responsive from 'react-responsive';
import YouTube from '@u-wave/react-youtube';
import Modal from 'react-responsive-modal';
import ReactGA from 'react-ga';
import {Helmet} from "react-helmet";
import LookWhosTalkingSlider from '../../components/explain/LookWhosTalkingSlider';
import AnimationSlogan from './animationSlogan';
import * as util from '../../utils/util';
import './Home.css';
import { Phone, Tablet, Desktop, NotPhone } from '../../utils/styles';
import { logosArr } from '../../data/gate-fee-brands';
import { buttonsContentManage } from "../../utils/util";
import CommunityItem from './communityItem'

import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import Api from '../../utils/api';

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openModal: false,
            userNumber: null,
            maxUserNumber: 500854,
            showStickyQuiz: false,
            bigMessageTextArray: ["acne","dryness","redness","mature","oiliness"],
            bigMessageShowText: 'acne',
            bigMessageShowindex: 0,
            visitedRecommendations: false,
            openHomeConfirmModal:true,
            freeShipping:false,
            communityData:[
                {
                    leftImg:'./images/home/community/Brittany/020920_Hello_Ava_Shot_2.jpg',
                    rightImg:'./images/home/community/Brittany/Brittany.jpg',
                    titleText:'Brittany’s story',
                    isShowfullTimeMon:true,
                    typeImg1:'./images/home/community/Brittany/Hormonalacne.svg',
                    typeImgText1:'Hormonal acne',
                    typeImg2:'./images/home/community/Brittany/Sensitiveskin.svg',
                    typeImgText2:'Sensitive skin',
                    contenText:'Brittany’s skincare needs drastically changed during her pregnancy, leaving her helpless and unsure how to even begin tackling her hormonal acne'
                },
                {
                    leftImg:'./images/home/community/Tatiana/020920_Hello_Aa__Shot_1.jpg',
                    rightImg:'./images/home/community/Tatiana/Tatiana.jpg',
                    titleText:'Tatiana’s story',
                    isShowfullTimeMon:false,
                    typeImg1:'./images/home/community/Tatiana/Dullness.svg',
                    typeImgText1:'Dullness',
                    typeImg2:'./images/home/community/Tatiana/CloggedPores.svg',
                    typeImgText2:'Clogged pores',
                    contenText:'Like so many others, Tatiana tried to self-diagnose the roots of her skin issues - dullness and clogged pores but she didn’t find any good solution.'
                },
                {
                    leftImg:'./images/home/community/Asiana/020920_Hello_Aa_Shot_3.jpg',
                    rightImg:'./images/home/community/Asiana/Asiana.jpg',
                    titleText:'Asiana’s story',
                    isShowfullTimeMon:false,
                    typeImg1:'./images/home/community/Asiana/AdultAcne.svg',
                    typeImgText1:'Adult Acne',
                    typeImg2:'./images/home/community/Asiana/ExtremeDryness.svg',
                    typeImgText2:'Extreme dryness',
                    contenText:'Asiana has found herself battling with adult acne while having dry skin. Through the endless testing of products, her skin has become even more sensitive and acne-prone.'
                },
            ],
            communitySliderSettings:{
                dots: true,
                infinite: true,
                speed: 600,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows:false,
                autoplay: true,
                autoplaySpeed:4000,
                fade: true,
                pauseOnHover: false,
                customPaging: function(i) {
                    return (
                      <i className="custom-dots-s"></i>
                    );
                },
                dotsClass: "slick-dots slick-thumb community-slickdots",
            },   

        };

        this.toggleStickyQuizButton = this.toggleStickyQuizButton.bind(this);
        this.goToQuiz = this.goToQuiz.bind(this);
        this.handleDownArrowClick = this.handleDownArrowClick.bind(this);
        this.fun_homeStaredButton = this.fun_homeStaredButton.bind(this);
    }

    componentWillMount() {
        this.getMaxUserNumber();
    }

    componentDidMount() {
        // window.addEventListener('scroll', this.toggleStickyQuizButton, false);
        //标注用户的来源，从哪个网站过来的  合作结束功能关闭了
        // const query_params = new URLSearchParams(this.props.location.search);
        // const utm_source = query_params.get("utm_source");
        // if(utm_source){
        //     sessionStorage.setItem("utm_source",utm_source);
        // }else{
        //     sessionStorage.removeItem("utm_source");
        // }

        // actionFunction: 用户第一次访问主页，展示海报图
        // 暂时先注释，有改动
        // if(localStorage.getItem("home-freeShippingAlertPop") != "true" ){
        //     setTimeout(()=>{
        //         this.setState({freeShipping:true});
        //         localStorage.setItem("home-freeShippingAlertPop",'true')
        //     },3000)    
        //  }

        window.scrollTo(0, 0);
        const userId = localStorage.getItem("user_id");

        if( localStorage.getItem("visited_recommendations") == "true" ){
            this.setState({visitedRecommendations: true});
        }else{
            this.setState({visitedRecommendations: false});
        }     

        if(userId && userId!=''){
          this.setState({
            openHomeConfirmModal:false  
          })                    
        }

        try {
            document.getElementById("home-page").addEventListener("touchstart", this.fun_videoPlay);
            document.addEventListener("visibilitychange",function(){
                if(document.visibilityState === "hidden"){
                    document.getElementById("helloavaVideo").pause();
                }else if(document.visibilityState === "visible"){
                    document.getElementById("helloavaVideo").play();
                }

            })
        } catch (error) {
            console.log(error)
        }


    }

    componentWillUnmount(){
        try {
            document.getElementById("home-page").removeEventListener("touchstart", this.fun_videoPlay);
            document.getElementById("helloavaVideo").pause();
            document.addEventListener("visibilitychange");
        } catch (error) {
            console.log(error);
        }
      
    }

    fun_videoPlay(){
        try {
            document.getElementById("helloavaVideo").play();
        } catch (error) {
            
        }
    }

    gtag_report_conversion_get_started(url) {
        let callback = function () {
        if (typeof(url) !== 'undefined') {
          window.location = url;
            }
        };
        if(window.gtag)
        window.gtag('event', 'conversion', {
              'send_to': 'AW-782420739/tzYpCN279owBEIOWi_UC',
              'event_callback': callback
        });
        return false;
    }

    getMaxUserNumber() {
        // fetch('/api/user-numbers/max', {
        //     method: 'GET',
        //     headers: {
        //         'Accept': 'application/json',
        //         'Content-Type': 'application/json'
        //     }
        // }).then((response) => response.json()).then(responseJson => {
        //     this.setState({
        //         maxUserNumber: responseJson
        //     });
        // }).catch(function(err) {
        //     console.log("There was a problem occurred. Please try again.");
        // });
    }

    // eventTrackingIconClicked(iconTag) {
    //     if (process.env.REACT_APP_ENV !== 'prod') {
    //         if (iconTag === 'desktop') {
    //             ReactGA.event({
    //                 category: 'Chat',
    //                 action: 'Click',
    //                 label: 'Desktop',
    //                 value: 1
    //             });
    //         } else if (iconTag === 'facebook-messenger') {
    //             ReactGA.event({
    //                 category: 'Chat',
    //                 action: 'Click',
    //                 label: 'Facebook Messenger',
    //                 value: 1
    //             });
    //         } else if (iconTag === 'sms') {
    //             ReactGA.event({
    //                 category: 'Chat',
    //                 action: 'Click',
    //                 label: 'SMS',
    //                 value: 1
    //             });
    //         }
    //     }
    // }

    gotoOnboarding() {
        window.fbq('track', 'Lead');
        if (process.env.REACT_APP_ENV === 'prod') {

            ReactGA.event({
                category: 'TakeQuiz',
                action: 'Click',
                label: 'MainCTA',
                value: 1
            });
            this.gtag_report_conversion_get_started();
        }
    }

    gotoOnRecommednations() {
        this.props.history.push('/recommendations');
    }

    openModal() {
        this.setState({ openModal: true });
        if (process.env.REACT_APP_ENV === 'prod') {
            ReactGA.event({
                category: 'Video',
                action: 'Click',
                label: 'Watch Video',
                value: 1
            });
        }
    }
    closeHomeConfirmModal(){
      this.setState({
        openHomeConfirmModal:false  
      })
    }

    toggleStickyQuizButton() {
        if (window.pageYOffset >= 400) {
            this.setState({ showStickyQuiz: true });
        } else {
            this.setState({ showStickyQuiz: false });
        }
    }

    goToQuiz(section) {
        this.handleGotoShop()
        return false;
        window.fbq('track', 'Lead');
        let url = buttonsContentManage();
        this.props.history.push(url);
        if (process.env.REACT_APP_ENV === 'prod'  &&  (url == '/onboarding' || url == '/startonboarding')  ) {
            let label = 'Our Process - ' + section;
            ReactGA.event({
                category: 'TakeQuiz',
                action: 'Click',
                label: label,
                value: 1
            });
        }
    }
    
    handleDownArrowClick() {
        const whatHappensNext = document.getElementById("what-happens-next");
        whatHappensNext.scrollIntoView({ behavior: "smooth" });
    }

    closeModal() {
        this.setState({ openModal: false });
    }

    fun_Roll(){
        const whatHappensNext = document.getElementById("what-happens-next");
        whatHappensNext.scrollIntoView({ behavior: "smooth" });
    }

    handleGotoShop(){
        window.location.href = 'http://shop.helloava.co/';
    }
    
    fun_homeStaredButton(){
        // this.props.history.push('/startonboarding');
        window.location.href = 'http://shop.helloava.co/';
    }

    render() {
        let brandLogos = [];
        let brandLogosPhone = [];
        const blSlice = 6;
        const blpSlice = 3;
        const numOfLogos = logosArr.length;

        for (let index = 0; index < numOfLogos; index += blSlice) {
            const blRow = logosArr.slice(index, index + blSlice).map((img, i) => {
                return(
                    <div key={ i + index } className="logo"><img alt={ img } src={img} /></div>
                );
            });
            brandLogos.push(<div key={ index } className="logos-row">{ blRow }</div>);
        }
        for (let indexPhone = 0; indexPhone < numOfLogos; indexPhone += blpSlice) {
            const blpRow = logosArr.slice(indexPhone, indexPhone + blpSlice).map((img, i) => {
                return(
                    <div key={ i + indexPhone } className="logo"><img alt={ img } src={img} /></div>
                );
            });
            brandLogosPhone.push(<div key={ indexPhone } className="logos-row">{ blpRow }</div>);
        }

        const settings = {
            arrows: false,
            dots: true,
            infinite: true,
            autoplay: true,
            autoplaySpeed:3000,
            speed: 600,
            slidesToShow: 1,
            slidesToScroll: 1,
            pauseOnHover: false
        };

        const settingsPhone = {
            arrows: false,
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed:3000,
            speed: 600,
            slidesToShow: 1,
            slidesToScroll: 1,
            pauseOnHover: false
        };

        const settingsAlt = {
            arrows: false,
            dots: true,
            infinite: true,
            autoplay: false,
            autoplaySpeed:3000,
            speed: 600,
            slidesToShow: 1,
            slidesToScroll: 1,
            draggable: false,
            pauseOnHover: false
        };

        const { maxUserNumber } = this.state;
        const displayedUserNumber = maxUserNumber ? parseInt(process.env.REACT_APP_USER_BASE) + maxUserNumber - parseInt(process.env.REACT_APP_USER_NUMBER_IN_DB) : null;
        const displayedRec = maxUserNumber ? Math.ceil((parseInt(process.env.REACT_APP_USER_BASE) + maxUserNumber - parseInt(process.env.REACT_APP_USER_NUMBER_IN_DB)) * 8.6) : "";
        return (
            <div className="home" id="home-page">
                <Helmet>
                    <title>HelloAva - The Brains Behind Your Beauty | Personalized Skincare Routines</title>
                    <meta name="description" content="Discover the best skincare products for your skin's unique needs, powered by artificial intelligence and human expertise." />
                </Helmet>
                <div className="section-1 top-personalized-bg">
                    {/* <div className="home-hero-img-container">
                        <Responsive minWidth={ 1280 }>
                            <img alt="HelloAva - The brains behind your beauty" className="lazyload" data-src="/images/home/helloavaHomeBG.png" />
                        </Responsive>
                        <Responsive minWidth={ 1024 } maxWidth={ 1279 }>
                            <img alt="HelloAva - The brains behind your beauty" className="lazyload" data-src="https://res.cloudinary.com/dhybuxeqg/image/upload/f_auto/v1578902142/hello/images/home/header-bottles-1024px_h8fjqc.png" src="https://res.cloudinary.com/dhybuxeqg/image/upload/f_auto/v1578902142/hello/images/home/header-bottles-1024px_h8fjqc.png" />
                        </Responsive>

                        <Phone>
                            <img alt="HelloAva - The brains behind your beauty" className="lazyload" data-src="https://res.cloudinary.com/dhybuxeqg/image/upload/f_auto/v1578902007/hello/images/home/mobile/header-bottles-phone_twjzq4.png" src="https://res.cloudinary.com/dhybuxeqg/image/upload/f_auto/v1578902007/hello/images/home/mobile/header-bottles-phone_twjzq4.png" />
                        </Phone>
                        <Tablet>
                            <img alt="HelloAva - The brains behind your beauty" className="lazyload" data-src="https://res.cloudinary.com/dhybuxeqg/image/upload/f_auto/v1578902007/hello/images/home/mobile/header-bottles-tablet_eh25zf.png" src="https://res.cloudinary.com/dhybuxeqg/image/upload/f_auto/v1578902007/hello/images/home/mobile/header-bottles-tablet_eh25zf.png" />
                        </Tablet>
                    </div> */}
                    <div className="hero-message">

                        
                        
                        <Responsive minWidth={ 767 }>
                            <div className="big-message">Personalized skincare</div>
                            <div className="big-message">solutions for your  <AnimationSlogan/> </div>
                        </Responsive>

                        <Responsive maxWidth={ 767 }>
                            <div className="big-message">Personalized</div>
                            <div className="big-message">skincare solutions </div>
                            <div className="big-message">for your  <AnimationSlogan/> </div>
                        </Responsive>

                        <div className="small-message">Goodbye guesswork. Hello good skin! For as little as $10.</div>


                        <a onClick={ ()=>{ this.handleGotoShop()  }} href="javascript:void(0);">
                            <button className="button-size-a home-button-top">{ buttonsContentManage('buttonText') }</button>
                        </a>

                        <div className="play-video">
                            <img alt="Play" src="/images/home/play-button.svg" />
                            <a onClick={ this.openModal.bind(this) }>Here's how we do it</a>
                        </div>
                    </div>
{/*                         
                    <i className="bg-icon top-left-bg-icon"></i>
                    <i className="bg-icon top-right-bg-icon"></i>
                    <i className="bg-icon center-left-bg-icon"></i>
                    <i className="bg-icon center-right-bg-icon"></i>
                    <i className="bg-icon bottom-left-bg-icon"></i>
                    <i className="bg-icon bottom-right-bg-icon"></i>
                     */}
                    {/* <i className="bg-icon bottom-center-array-icon" onClick={()=>{ this.fun_Roll() }}></i> */}

                </div>


                <div id="our-process">
                <div className={ this.state.showStickyQuiz ? "our-process-sticky-quiz" : "our-process-sticky-quiz hidden" }>
                     <div className="hero-button">
                        <button onClick={ () => this.goToQuiz("Sticky Header") } >{buttonsContentManage("buttonText")} </button>
                    </div>
                </div>
                <div className="our-process-body">
                    <div id="what-happens-next" className="our-process-section what-happens-next">
                        <h2 className="our-process-title">How it works</h2>
                        <div className="our-process-area">
                            <div className="step-row step-1">
                                <div className="row-img-area">
                                    <img alt="01 - Skin Profile" className="assesement-img lazyload" data-src="/images/home/Assesement.png" />  
                                </div>
                                <div className="row-text" >
                                    <h3 className="skin-text">
                                        <div className="h4-title-co">Brief skin assessment</div>
                                    </h3>
                                    <div className="step-row-grey-text paragraph1" style={{color: '#4C4E56'}}>
                                        <div>Tell us about your skin</div>
                                        <div>and lifestyle</div>
                                    </div>
                                </div>
                            </div>

                            <div className="step-row step-2">
                                <div className="row-img-area">
                                    <img alt="02" className="consult-img lazyload" data-src="images/home/Consult.png" />
                                </div>
                                <div className="row-text">
                                    <h3 className="skin-text">
                                        <div className="h4-title-co">Skin consultation</div>
                                    </h3>
                                    <div className="step-row-grey-text paragraph1" style={{color: '#4C4E56'}}>
                                        <div>Receive tailored guidance</div>
                                        <div>from a licensed esthetician for $10</div>
                                    </div>
                                </div>
                            </div>

                            <div className="step-row step-3">
                                <div className="row-img-area">
                                    <img alt="03" className="recs-img lazyload" data-src="images/home/Recs.png" />
                                </div>
                                <div className="row-text" >
                                    <h3 className="skin-text">
                                        <div className="h4-title-co">Personalized routine</div>
                                    </h3>
                                    <div className="step-row-grey-text paragraph1" style={{color: '#4C4E56'}}>
                                        <div>Get your effective</div> 
                                        <div> products delivered</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            localStorage.getItem("auth_token") ? null:
                                <div className="row-button">
                                    <button className="button-orange button-size-a" onClick={this.fun_homeStaredButton}>Get Started</button>
                                </div>
                        }
                    </div>


                    <div className="consultation-area">
                        <div className="plan-area-style">
                            <h2>What’s in a consultation</h2>
                            <Responsive minWidth={ 769 }>
                                <div className="consultation-icon-text">
                                    <span className="paragraph1"><img src="/images/home/vector1.svg"/>Video</span>
                                    <span className="paragraph1"><img src="/images/home/vector2.svg"/>Text</span>
                                    <span className="paragraph1"><img src="/images/home/vector3.svg"/>Phone</span>
                                </div>
                            </Responsive>
                        

                            <div className="consultation-info-img-text-but">
                                <div className="consultation-info-img-text">
                                    
                                    <Responsive maxWidth={ 768 }>
                                        <div className="img-info-area" style={{justifyContent: 'center'}}>
                                            <img className="routine-img" src="/images/home/mobile/consultMobile.png"/>
                                        </div>
                                    </Responsive>   

                                    <Responsive maxWidth={ 768 }>
                                        <div className="consultation-icon-text">
                                            <span className="paragraph1"><img src="/images/home/vector1.svg"/>Video</span>
                                            <span className="paragraph1"><img src="/images/home/vector2.svg"/>Text</span>
                                            <span className="paragraph1"><img src="/images/home/vector3.svg"/>Phone</span>
                                        </div>
                                    </Responsive>

                                    <div className="text-info-area">
                                        <div className="text-info-area-row">
                                            <div className="h4-title-co">Keep what works</div>
                                            <div className="paragraph1">We incorporate our recommendations with what’s working in your current routine</div>
                                        </div>
                                        <div className="row-text-m text-info-area-row">
                                            <div className="h4-title-co">Skin analysis</div>
                                            <div className="paragraph1">We will take an in-depth look at your skin and get to the root of your concerns</div>
                                        </div>
                                        <div className="row-text-m text-info-area-row">
                                            <div className="h4-title-co">Ingredients first</div>
                                            <div className="paragraph1">We inform you on the most effective ingredients for your skin’s needs</div>
                                        </div>
                                        <div className="row-text-m">
                                            <div className="h4-title-co">Build your routine</div>
                                            <div className="paragraph1">We’ll customize a routine with a holistic approach to achieve your skin goals</div>
                                        </div>
                                    </div>

                                    <Responsive minWidth={ 769 }>
                                        <div className="img-info-area">
                                            <img className="routine-img" src="/images/home/Group425.png"/>
                                            <img className="consul-img" src="/images/home/Group418.png"/>
                                        </div>
                                    </Responsive>                                
                                </div>
                                {
                                    localStorage.getItem("auth_token") ? null:
                                    <Responsive minWidth={ 767 }>
                                        <div className="consultation-info-but row-button">
                                            <button className="button-orange button-size-a" onClick={ this.fun_homeStaredButton}> Get Started </button> 
                                        </div>
                                    </Responsive>
                                }
                            </div>
                        </div>
                    </div>

                    <div className="our-founders our-process-section">
                        <div className="our-founders-text-video">
                            <div className="our-founders-text-video-area">
                                <h2>A note from our founders</h2>

                                <div className="our-founders-text">
                                    {/* <div className="our-founders-text-title h4-title-co">Your skin is unique</div> */}
                                    <div className="our-founders-text-conten paragraph1" style={{color:'#4C4E56'}}>“At HelloAva, we believe in educating and empowering our community. Skincare can be overwhelming. We want to help you understand what ingredients work best for your skin and why. We will always be here for you as your skin changes.”</div>
                                    <div className="si-kai-show-area">

                                        <div className="headPortrait-area">
                                            <div className="headPortrait-name paragraph3 charcoal">Siqi Mou, Kailu Guan</div>
                                            <div className="headPortrait-img">
                                                {/* <img src="/images/home/siqi.svg"></img>
                                                <img src="/images/home/kailu.svg"></img> */}
                                                <img src="https://res.cloudinary.com/dhybuxeqg/image/upload/c_scale,f_auto,w_1000,c_fill,ar_1:1,g_auto,r_max/v1616679433/hello/images/home/siqi_px88g7.jpg"></img>
                                                <img src="https://res.cloudinary.com/dhybuxeqg/image/upload/c_scale,f_auto,w_1000,c_fill,ar_1:1,g_auto,r_max/v1616679433/hello/images/home/kailu_wkvvpw.jpg"></img>
                                            </div>
                                        </div>

                                        <div className="autograph-area">
                                            <img src="/images/home/siqisignature.png"></img>
                                            <img src="/images/home/kailusignature.png"></img>
                                        </div>
                                        
                                    </div>
                                </div>
                                <Responsive minWidth={ 767 }>
                                {
                                    localStorage.getItem("auth_token") ? null:
                                        <div className="row-button our-fou-but">
                                            <button className="button-orange button-size-a" onClick={this.fun_homeStaredButton}>Get Started</button>
                                        </div>
                                }
                                </Responsive>
                            </div>

                            <div className="our-founders-video">
                                    <video x-webkit-airplay="allow" x5-playsinline="" webkit-playsinline="" playsInline={true} id="helloavaVideo" muted controls="controls" width="100%" height="100%" autoPlay="autoplay" loop="loop" src="/images/home/HelloAvaFinalsmall.mp4">Your browser does not support video tags</video>
                            </div>
                           
                            <Responsive maxWidth={ 767 }>
                                {
                                    localStorage.getItem("auth_token") ? null:
                                        <div class="row-button our-fou-but">
                                            <button className="button-orange button-size-a" onClick={this.fun_homeStaredButton}>Get Started</button>
                                        </div>
                                }
                            </Responsive>
                            
                        </div>
                    </div>

{/*                             
                    <div className="our-process-section what-will-you-get">
                        <div className="what-will-you-get-content">
                            <h2>What you will get</h2>
                            <div className="block">
                                <img alt="check" src="/images/gate/check-icon.svg" />
                                <div className="column">
                                    <div className="title"><span>Skincare products</span> that are curated for your needs and skin type</div>
                                </div>
                            </div>
                            <div className="block">
                                <img alt="check" src="/images/gate/check-icon.svg" />
                                <div className="column">
                                    <div className="title">A <span>personalized regimen card</span> that tells you how to use your products step-by-step</div>
                                </div>
                            </div>
                            <div className="block">
                                <img alt="check" src="/images/gate/check-icon.svg" />
                                <div className="column">
                                    <div className="title">On-demand <span>skin consultation (optional)</span></div>
                                </div>
                            </div>
                            <div className="block">
                                <img alt="check" src="/images/gate/check-icon.svg" />
                                <div className="column">
                                    <div className="title">Product refills at <span>10% off</span></div>
                                </div>
                            </div>
                                <div className="hero-button">
                                    <NavLink to={ !localStorage.getItem("auth_token") ? "/onboarding" : buttonsContentManage() }>
                                        <button>{ !localStorage.getItem("auth_token") ? "START SKIN QUIZ" : "RECOMMENDATIONS" }</button>
                                    </NavLink>
                                </div>
                            <div className="triangle">
                            </div>
                        </div>
                        <div className="what-will-you-get-image">
                            <img alt="HelloAva - What skincare products will you get?" className="lazyload" data-src="https://res.cloudinary.com/dhybuxeqg/image/upload/f_auto/v1601979648/hello/images/explain/section3/rec-landing_swdjkm.png" />
                        </div>
                    </div> */}

                    
                    <div className="our-process-section look-whos-talking">
                        {/* <h2>Look who's talking</h2> */}
                        <div style={{padding:'15px 4%',backgroundColor:'#FAF8F6'}}>
                            <LookWhosTalkingSlider />
                        </div>
                        
                    </div>


                    <div className="our-process-section our-community">
                        <h2 className="our-community-title" style={{marginBottom:'1.4rem'}}>Hear from our community</h2>
                        <div className="sidle-section-zone our-community-zone" name="community-section-zone">
                            <Slider { ...this.state.communitySliderSettings }>
                                {
                                    this.state.communityData.map((item, index)=>{
                                      return <CommunityItem data={item} key={index}></CommunityItem>
                                    })
                                }
                            </Slider>                
                        </div>

                    </div>
{/*                     
                    <div className="our-process-section skin-advisors">
                        <h2>A team of licensed skincare advisors and dermatologists is only a text away</h2>
                        <div className="subtitle">Have any questions about your skin or your products? Your dedicated skincare advisor is here to help</div>
                        <div className="skin-advisor-blocks">
                            <Responsive minWidth={ 501 }>
                                <div className="our-process-block skin-advisor-block team-image">
                                    <img alt="HelloAva skin advisors" className="lazyload" data-src="/images/explain/section5/team.png" />
                                </div>
                                <div className="our-process-block skin-advisor-block msg-image">
                                    <img alt="Questions to ask your skin advisor" className="lazyload" data-src="/images/explain/section5/msg1.png" />
                                </div>
                            </Responsive>
                            <Responsive maxWidth={ 500 }>
                                <div className="our-process-block skin-advisor-block mobile-image">
                                    <div className="mobile-image-container">
                                        <img alt="Bianca Richard - Licensed Aesthetician" className="lazyload" data-src="https://res.cloudinary.com/dhybuxeqg/image/upload/f_auto/v1578900968/hello/images/explain/section5/team-mobile-1_l8euv5.png" />
                                    </div>
                                    <div className="advisor-name">Kathleen Callahan</div>
                                    <div className="advisor-title">Licensed Esthetician</div>
                                </div>
                                <div className="our-process-block skin-advisor-block mobile-image">
                                    <div className="mobile-image-container">
                                        <img alt="Frannelys Diaz - Licensed Aesthetician" className="lazyload" data-src="https://res.cloudinary.com/dhybuxeqg/image/upload/f_auto/v1578900967/hello/images/explain/section5/team-mobile-2_vd5uda.png" />
                                    </div>
                                    <div className="advisor-name">Kimberley Broomes</div>
                                    <div className="advisor-title">Licensed Esthetician</div>
                                </div>
                                <div className="our-process-block skin-advisor-block mobile-image">
                                    <div className="mobile-image-container">
                                        <img alt="Lian Mack, MD - Board Certified Dermatologist" className="lazyload" data-src="https://res.cloudinary.com/dhybuxeqg/image/upload/f_auto/v1578900967/hello/images/explain/section5/team-mobile-3_jna3tw.png" />
                                    </div>
                                    <div className="advisor-name">Lian Mack, MD</div>
                                    <div className="advisor-title">Board Certified Dermatologist</div>
                                </div>
                            </Responsive>
                        </div>
                    </div> */}

                    <div className="our-process-bg-sections">
                        <div className="our-process-section data-driven">
                            <h2>HelloAva’s data-driven curation</h2>
                            <Responsive minWidth={ 501 }><div className="subtitle">We use AI and machine learning to provide you with highly accurate, personalized recommendations</div></Responsive>
                            <div className="data-driven-blocks">
                                <Responsive minWidth={ 501 }>
                                    <div className="our-process-block data-driven-block data-left">
                                        <img alt="HelloAva matching score" className="lazyload" data-src="https://res.cloudinary.com/dhybuxeqg/image/upload/f_auto/v1578901241/hello/images/explain/section6/data-left_v4kvam.png"/>
                                    </div>
                                    <div className="our-process-block data-driven-block data-right">
                                        <img alt="HelloAva data-driven solutions for your skincare needs" className="lazyload" data-src="https://res.cloudinary.com/dhybuxeqg/image/upload/f_auto/v1578901241/hello/images/explain/section6/data-right_k8f9uh.png" />
                                    </div>
                                </Responsive>
                                <Responsive maxWidth={ 500 }>
                                    <div className="our-process-block data-driven-block data-left">
                                        <img alt="HelloAva's data-driven matching score" className="lazyload" data-src="/images/explain/section6/data-left-mobile.png" />
                                    </div>
                                    <div className="our-process-block data-driven-block data-right">
                                        <img alt="HelloAva uses data to help match products with your skin concerns" className="lazyload" data-src="/images/explain/section6/data-right-mobile.png" />
                                    </div>
                                </Responsive>
                            </div>
                            <div className="hero-button"><button className="button-size-a" onClick={ () => this.goToQuiz("What You Will Get") }>{ buttonsContentManage('buttonText') } </button></div>
                        </div>
                    </div>
                    <div className="our-process-section brands-trust">
                        <h2>Brands we trust</h2>
                        <div className="logos side-space">
                            <NotPhone>
                                { brandLogos }
                            </NotPhone>
                            <Phone>
                                { brandLogosPhone }
                            </Phone>
                        </div>
                        <div className="and-more"><a href="/our-story">And more! Check out our vetting process here</a></div>
                    </div>

{/*                     
                   <div className="our-process-section examples">
                        <h2>Products that work, no matter your skin type</h2>
                        <Responsive minWidth={ 501 }><div className="subtitle">Check out some examples of what other members have received below</div></Responsive>
                        <div className="example-rows">
                            <div className="example-row">
                                <div className="example-block">
                                    <img alt="OSHM skincare regimen" className="lazyload"  data-src="https://res.cloudinary.com/dhybuxeqg/image/upload/c_scale,f_auto,w_284/v1578556973/hello/images/explain/section8/oshm_jx1hgk.jpg" />
                                    <div className="example-text">
                                        <h4>Nicole</h4>
                                    </div>
                                </div>
                                <div className="example-block">
                                    <img alt="ORLY skincare regimen" className="lazyload" data-src="https://res.cloudinary.com/dhybuxeqg/image/upload/v1578386022/hello/images/explain/section8/orly_ntauey.jpg" />
                                    <div className="example-text">
                                        <h4>Alex</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="example-row">
                                <div className="example-block">
                                    <img alt="DRLY skincare regimen" className="lazyload" data-src="https://res.cloudinary.com/dhybuxeqg/image/upload/v1584521122/hello/images/explain/section8/drly_wo4qyj.jpg" />
                                    <div className="example-text">
                                        <h4>Joe</h4>
                                    </div>
                                </div>
                                <div className="example-block">
                                    <img alt="DRHM skincare regimen" className="lazyload" data-src="https://res.cloudinary.com/dhybuxeqg/image/upload/c_scale,f_auto,w_284/v1578556973/hello/images/explain/section8/drhm_g7og8z.jpg" />
                                    <div className="example-text">
                                        <h4>Frida</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="hero-button">
                            <button onClick={ () => this.goToQuiz("What You Will Get") } className="button-size-a">
                                {
                                    localStorage.getItem("user_has_skin_profile") ? 'RETAKE SKIN QUIZ' : 'START SKIN QUIZ'
                                }
                            </button>
                        </div>            
                    </div>
                     */}

                    <div className="our-process-section risk-free">
                        <h2>Get Better Skin with No Risk</h2>
                        <div className="risk-free-blocks">
                            <div className="risk-free-row">
                                <div className="risk-free-block">
                                    <div className="risk-free-content">
                                        <img alt="Match your budget" className="img_credit lazyload" src="/images/explain/section4/offCredit.svg"  data-src="/images/explain/section4/offCredit.svg" />
                                        <div className="risk-free-content-text">
                                            {/* <h3>$10 consultation fee will be credited towards your purchase</h3> */}
                                            <h3>15% off first order</h3>
                                        </div>
                                    </div>
                                    <div className="risk-free-square" />
                                </div>
                                <div className="risk-free-block">
                                    <div className="risk-free-content">
                                        <img alt="No subscription" className="img_risk lazyload" data-src="/images/explain/section4/risk.svg"/>
                                        <div className="risk-free-content-text">
                                            <h3 style={{marginBottom:'8px'}}>Risk-free skin consultation</h3>
                                            {/* <div className="sub-note">
                                                <div>If you aren’t happy with your</div>
                                                <div>recommendations, we will</div>
                                                <div>refund you the $10</div>
                                            </div> */}
                                        </div>
                                    </div>
                                    <div className="risk-free-square" />
                                </div>
                            </div>
                            <div className="risk-free-row">
                                <div className="risk-free-block">
                                    <div className="risk-free-content">
                                        <img className="img_match lazyload" data-src="/images/explain/section4/match.svg" alt="$10 skincare consultation fee credited towards your purchase" />
                                        <div className="risk-free-content-text">
                                            <h3>We’ll match<br/>your budget</h3>
                                        </div>
                                    </div>
                                    <div className="risk-free-square" />
                                </div>
                                <div className="risk-free-block">
                                    <div className="risk-free-content">
                                        <img alt="Free returns" data-src="/images/explain/section4/subscription.svg" className="img_subscr lazyload" />
                                        <div className="risk-free-content-text">
                                            <h3>No subscription required</h3>
                                            {/* <div className="sub-note">
                                                *for unopened and unused products, within 30 days
                                            </div> */}
                                        </div>
                                    </div>
                                    <div className="risk-free-square" />
                                </div>
                            </div>
                        </div>
                        
                        <div className="hero-button" style={{width:'100%'}}>
                            <a onClick={ ()=>{ this.handleGotoShop()  }} href="javascript:void(0);">   
                                <button className="button-size-a">{ buttonsContentManage('buttonText') }</button>
                            </a>    
                        </div>
                    </div>




                    <div className="our-process-section numbers-share numbers-share-update">
                        <h2>HelloAva by the numbers</h2>
{/*     
                        <div className="numbers-share-row">
                            <div className="numbers-share-block">
                                <div className="share-number">{ !isNaN(parseInt(displayedUserNumber, 10)) ? util.numberWithCommas(Math.round(displayedUserNumber / 1000) * 1000) + "+" : "34,000+" }</div>
                                <div className="numbers-text">active users</div>
                            </div>
                            
                            <div className="numbers-share-block">
                                <div className="share-number">1.6m</div>
                                <div className="numbers-text">skincare consultation messages sent</div>
                            </div>
                        </div>
                        <div className="numbers-share-row">
                            <div className="numbers-share-block">
                                <div className="share-number">{ !isNaN(parseInt(displayedRec, 10)) ? util.numberWithCommas(Math.round(displayedRec / 1000) * 1000) + "+" : "294,000+" }</div>
                                <div className="numbers-text">recommended products</div>
                            </div>
                            <div className="numbers-share-block">
                                <div className="share-number">96%</div>
                                <div className="numbers-text">of customers satisfied with their new purchases</div>
                            </div>
                        </div>
                                                 */}
                         

                            <div className="numbers-share-block numbers-block-update">
                                <div className="share-number">1.6m</div>
                                <div className="numbers-text">skincare consultation messages sent</div>
                            </div>

                            <div className="numbers-share-block numbers-block-update">
                                <div className="share-number">{ !isNaN(parseInt(displayedRec, 10)) ? util.numberWithCommas(Math.round(displayedRec / 1000) * 1000) + "+" : "294,000+" }</div>
                                <div className="numbers-text">recommended products</div>
                            </div>

                            <div className="numbers-share-block numbers-block-update">
                                <div className="share-number">96%</div>
                                <div className="numbers-text">of customers satisfied with their new purchases</div>
                            </div>

                    </div>
                    <div className="our-process-quiz-bottom">
                        <div className="hero-bottom">
                            <div className="hero-section-bottom">
                                <h3>{ this.props.isAuthenticated ? "Need to make updates to your profile?" : "Ready to begin your skincare journey?" }</h3>
                                <div className="hero-button">
                                    <button className="button-size-a" onClick={ () => this.goToQuiz("Footer") }>{buttonsContentManage('buttonText')}</button>
                                </div>
                                {
                                    !this.props.isAuthenticated ?
                                    <div className="bottom-signin">
                                        Have an account already? <a onClick={ ()=>{ this.handleGotoShop()  }} href="javascript:void(0);">Sign in</a>
                                    </div> :
                                    null
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

                <Modal open={ this.state.openModal } onClose={ this.closeModal.bind(this) } little={ true }
                    classNames={{ overlay: 'ha-overlay', modal: 'ha-modal--big' }}>
                    <Desktop><YouTube id="youtube-player" width={ 1011 } height={ 576 } video="RwW3AY5bFvo" autoplay showRelatedVideos={ false } /></Desktop>
                    <Tablet><YouTube id="youtube-player" width={ 640 } height={ 360 } video="RwW3AY5bFvo" autoplay showRelatedVideos={ false } /></Tablet>
                    <Phone><YouTube id="youtube-player" width={ 320 } height={ 180 } video="RwW3AY5bFvo" autoplay showRelatedVideos={ false } /></Phone>
                </Modal>
                
                <div className="home-freesh-modal" style={this.state.freeShipping?{display:'block'}:{display:'none'}}>
                    {/* <i className="home-modal-closeIcon" onClick={()=>{  this.closeHomeConfirmModal() }}>x</i> */}
                    <div className="freesh-over-bg"></div>
                    <div className="home-confirm-conten">
                        <div className="home-freeShippingStyle">
                        <i className="home-modal-closeIcon" onClick={()=>{  this.setState({freeShipping:false}) }}>x</i>
                        <Responsive minWidth={ 769 }>
                            <img src="/images/home/group_pc.jpg"></img>
                        </Responsive>
                        <Responsive maxWidth={ 769 }>
                            <img src="/images/home/group_phone.jpg"></img>
                        </Responsive>
                        </div>
                    </div>
                </div>            

                {/* 活动取消了。功能隐藏*/}
                {/* 
                <div className="home-confirm-modal" style={this.state.openHomeConfirmModal?{display:'block'}:{display:'none'}}>
                    <i className="home-modal-closeIcon" onClick={()=>{  this.closeHomeConfirmModal() }}>x</i>
                    <div className="home-confirm-conten">
                      <div className="left-conten">
                        <img src="/images/home/mobile/logoPink.jpg"></img>
                      </div>
                      <div className="right-conten">
                        <div className="right-conten-title">Own A Stake In </div>
                        <div className="right-conten-title">The Future of Beauty</div>
                        <div className="right-conten-url-but">
                          <a target={ isMobile(navigator.userAgent) ? "_self" : "_blank" } href="https://republic.co/helloava/?utm_source=helloavasitehome&utm_medium=banner&utm_campaign=homepage">Join us now</a>
                        </div>
                      </div>
                    </div>
                </div> 
                */}
                {/* 活动取消了。功能隐藏*/}
                {/* 加个注释 */}

            </div>
        );
    }
}

function mapStateToProps(state) {
    const { helloava } = state;
    const { isAuthenticated } = helloava.auth;
    return { isAuthenticated };
}

export default withRouter(connect(mapStateToProps, null)(Home));



// WEBPACK FOOTER //
// ./src/views/home/Home.js